// extracted by mini-css-extract-plugin
module.exports = {"Ad":"GoogleAd_Ad__2cuZw","card":"GoogleAd_card__x1Ti3"};